














































import { Component, Vue, Prop } from 'vue-property-decorator';
import TabBoxComponent from '@/app/shared/components/toolbar/tab_box.vue';

@Component({
  components: { TabBoxComponent },
})
export default class BaseContentComponent extends Vue {
  @Prop(String) readonly title!: string;
  @Prop(String) readonly icon!: string;
  @Prop(Boolean) readonly stopPropagation!: boolean;

  err = false;
  vm = null;
  info = null;

  private errorCaptured(err: boolean, vm: null, info: null): boolean {
    this.err = err;
    this.vm = vm;
    this.info = info;
    return !this.stopPropagation;
  }
}
